import React, { useEffect, useMemo, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link, useLocation } from "react-router-dom";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import {
  Card,
  CardGroup,
  CardBody,
  CardHeader,
  CardHeaderBtn,
} from "./../../components/card/card.jsx";
import Swal from "sweetalert2";
import { Circles } from "react-loader-spinner";
import "moment/locale/es";
import Select from "react-select";

const customStyles = {
  control: (base) => ({
    ...base,
    borderColor: "transparent",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: "0",
    color: "white",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#fff",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    color: "black", // Text color for options
    backgroundColor: state.isFocused ? "transparent" : "transparent",
    "&:active": {
      backgroundColor: "transparent",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "white", // Color of the selected value
  }),
  input: (base) => ({
    ...base,
    color: "white", // Color of the input text
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "white", // Change the color of the dropdown indicator to white
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "white", // Change the color of the clear indicator to white
  }),
};

function UpdateDetail() {
  const [userModules, setUserModules] = useState(
    JSON.parse(localStorage.getItem("modulos")) || [],
  );

  const modules = userModules;
  const isAdmin = userModules.includes("admin");

  // Obtener la ubicación actual
  const location = useLocation();

  // Definir los tabs con su nombre, URL y módulo correspondiente
  const tabs = [
    { name: "Crear", to: "/deals/request", module: "deals-request" },
    { name: "Solicitudes", to: "/deals/update", module: "deals-update" },
    // { name: "Gráficas", to: "/deals/charts", module: "deals-charts" },
    { name: "Resumen", to: "/deals/requests", module: "deals-requests" },
    { name: "Ranking", to: "/deals/ranking", module: "deals-ranking" },
    // { name: "Facturado", to: "/deals/invoiced", module: "deals-invoiced" },
  ];

  const [mailData, setMailData] = useState([]);
  const [folioVentaSearch, setFolioVentaSearch] = useState("");
  const [loading, setLoading] = useState(false); // Estado para el loader
  const [selectedMailData, setSelectedMailData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [planesFinanciamientoState, setPlanesFinanciamientoState] = useState(
    [],
  );
  const [planSeleccionadoState, setPlanSeleccionadoState] = useState(null);
  const [editandoDatosReporte, setEditandoDatosReporte] = useState(false);
  const [datosReporteForm, setDatosReporteForm] = useState({
    marca_vehiculo: "",
    modelo_vehiculo: "",
    ano_vehiculo: "",
    version_vehiculo: "",
    precio_vehiculo: "",
    meses_financiamiento: "",
    enganche: "",
    mensualidad_estimacion: "",
  });

  const [filters, setFilters] = useState({
    asesor: "",
    financiera: "",
    motivo_rechazo: "",
    agencia: "",
    nombre: "",
    apellido_paterno: "",
  });

  const [filterOptions, setFilterOptions] = useState({
    asesor: [],
    financiera: [],
    status: [],
    agencia: [],
    nombre: [],
    startDate: "",
    endDate: "",
  });

  const statusOptionsCredito = [
    { label: "Sin status", value: "Sin status" },
    { label: "Autorizado", value: "Autorizado" },
    { label: "Rechazado", value: "Rechazado" },
    { label: "Pendiente de Buro", value: "Pendiente de Buro" },
  ];

  const subStatusOptionsCredito = {
    "Sin status": [{ label: "Sin substatus", value: "Sin substatus" }],

    Autorizado: [
      { label: "Condicionado Viable", value: "Condicionado Viable" },
      { label: "Condicionado No Viable", value: "Condicionado No Viable" },
      { label: "Facturado", value: "Facturado" },
      { label: "Formalizado", value: "Formalizado" },
      { label: "Aprobado Sin Formalizar", value: "Aprobado Sin Formalizar" },
    ],

    Rechazado: [{ label: "Rechazado", value: "Rechazado" }],

    "Pendiente de Buro": [
      { label: "Análisis", value: "Análisis" },
      { label: "Incompleto", value: "Incompleto" },
    ],
  };

  const statusOptionsContado = [
    { label: "Cotización", value: "Cotización" },
    { label: "Formalizado", value: "Formalizado" },
  ];

  // refs / estados auxiliares
  const [selectedFile, setSelectedFile] = React.useState(null);
  const fileInputRef = React.useRef(null);
  const inventarioRequestIdRef = React.useRef(0);

  const quitarAcentos = (str = "") =>
    str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const limpiarNumeroFormulario = (value = "") =>
    String(value ?? "")
      .replace(/,/g, "")
      .replace(/\$/g, "")
      .replace(/[^\d.-]/g, "")
      .trim();

  const numeroFormulario = (value = "") => {
    const limpio = limpiarNumeroFormulario(value);
    if (limpio === "") return 0;

    const numero = Number(limpio);
    return Number.isNaN(numero) ? 0 : numero;
  };

  const formatearNumeroInput = (value = "") => {
    const limpio = limpiarNumeroFormulario(value);

    if (limpio === "") return "";

    const esNegativo = limpio.startsWith("-");
    const sinSigno = limpio.replace(/-/g, "");
    const partes = sinSigno.split(".");
    const enteroRaw = partes[0] || "0";
    const decimalRaw = partes.length > 1 ? partes.slice(1).join("") : null;
    const entero = Number(enteroRaw || 0).toLocaleString("es-MX");
    const prefijo = esNegativo ? "-" : "";

    if (decimalRaw !== null) {
      return `${prefijo}${entero}.${decimalRaw.slice(0, 2)}`;
    }

    return `${prefijo}${entero}`;
  };

  const formatCurrency = (value = 0) =>
    `$${new Intl.NumberFormat("es-MX", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(numeroFormulario(value))}`;

  const mostrarTipoAuto = (value = "") => {
    const texto = String(value || "")
      .trim()
      .toLowerCase();

    if (!texto) return "Sin dato";

    return texto.charAt(0).toUpperCase() + texto.slice(1);
  };

  const plazoFinanciamientoOptions = [12, 24, 36, 48, 60, 72];

  const getMensualidadSolicitud = (data = {}) =>
    data?.mensualidad_estimacion ??
    data?.mensualidad ??
    data?.mensualidad_financiamiento ??
    data?.pago_mensual ??
    data?.mensualidad_aprobada ??
    data?.mensualidad_buscada ??
    "";

  const construirDatosReporteForm = (data = {}) => ({
    marca_vehiculo: data?.marca_vehiculo || "",
    modelo_vehiculo: data?.modelo_vehiculo || "",
    ano_vehiculo: data?.ano_vehiculo || "",
    version_vehiculo: data?.version_vehiculo || "",
    precio_vehiculo: formatearNumeroInput(data?.precio_vehiculo || ""),
    meses_financiamiento: limpiarNumeroFormulario(
      data?.meses_financiamiento || "",
    ),
    enganche: formatearNumeroInput(data?.enganche || ""),
    mensualidad_estimacion: formatearNumeroInput(getMensualidadSolicitud(data)),
  });

  const accessToken =
    "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3"; // El token de acceso
  const apiUrl = "https://api.checkmark.mx/solicitudes/consultar"; // La URL de la API
  const apiUrlUpdate = "https://api.checkmark.mx/solicitudes/actualizar";
  const apiUrlUpdateFormalizado =
    "https://api.checkmark.mx/solicitudes/actualizar/formalizado";

  const apiUrlUpdateStatus =
    "https://api.checkmark.mx/solicitudes/actualizar/status";
  const apiUrlUpdateSubStatus =
    "https://api.checkmark.mx/solicitudes/actualizar/sub_status";
  const apiUrlInventario = "https://api.checkmark.mx/financiamiento/vehiculos";
  const apiUrlUpdatePlanesSolicitudes =
    "https://api.checkmark.mx/actualizar/planes/solicitudes";
  // Servicio existente genérico: recibe venta_id y el/los campos a actualizar.
  const apiUpdateEstadoUrl =
    "https://api.checkmark.mx/actualizar/estado/financiamiento";
  const apiUrlMarcarIncompleto =
    "https://api.checkmark.mx/ventas/marcar-incompleto";

  const parseJsonSeguro = (value, fallback = []) => {
    if (!value) return fallback;
    if (Array.isArray(value)) return value;

    try {
      let parsed = JSON.parse(value);
      if (typeof parsed === "string") {
        parsed = JSON.parse(parsed);
      }
      return Array.isArray(parsed) ? parsed : fallback;
    } catch (error) {
      console.error("Error parseando JSON:", error);
      return fallback;
    }
  };

  const normalizar = (texto = "") =>
    String(texto || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const normalizarTexto = (texto = "") =>
    String(texto || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const getNombreCompleto = (cliente = {}) =>
    [cliente?.nombre, cliente?.apellido_paterno]
      .map((valor) => String(valor || "").trim())
      .filter(Boolean)
      .join(" ")
      .replace(/\s+/g, " ")
      .trim();

  const separarNombreCompleto = (nombreCompleto = "") => {
    const partes = String(nombreCompleto || "")
      .trim()
      .replace(/\s+/g, " ")
      .split(" ")
      .filter(Boolean);

    if (partes.length <= 1) {
      return {
        nombre: partes[0] || "",
        apellido_paterno: "",
      };
    }

    return {
      nombre: partes.slice(0, -1).join(" "),
      apellido_paterno: partes.at(-1) || "",
    };
  };

  const mailDataFiltradaPorFolio = useMemo(() => {
    const busqueda = normalizarTexto(folioVentaSearch);

    if (!busqueda) return mailData;

    return mailData.filter((registro) =>
      normalizarTexto(registro?.folio_venta || "").includes(busqueda),
    );
  }, [mailData, folioVentaSearch]);

  const limpiarModeloVersion = (texto = "") =>
    normalizarTexto(texto)
      .replace(/\b(2025|2026|2027|2028|2029|25|26|27|28|29)\b/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const escapeRegExp = (texto = "") =>
    String(texto).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const incluyePalabra = (texto = "", palabra = "") => {
    const textoLimpio = normalizarTexto(texto);
    const palabraLimpia = normalizarTexto(palabra);

    if (!textoLimpio || !palabraLimpia) return false;

    return new RegExp(`\\b${escapeRegExp(palabraLimpia)}\\b`, "i").test(
      textoLimpio,
    );
  };

  const estaDisponible = (item) =>
    item?.available === true ||
    item?.available === "true" ||
    item?.available === 1 ||
    item?.available === "1";

  const coincideAgenciaItem = (item, agIdActivo = "") => {
    const itemAgId = String(item?.ag_id || "")
      .trim()
      .toLowerCase();
    const agId = String(agIdActivo || "")
      .trim()
      .toLowerCase();

    if (!itemAgId || itemAgId === "all") return true;
    if (!agId) return false;

    return itemAgId === agId;
  };

  const coincideMarcaItem = (item, marcaActiva = "") => {
    const itemBrand = normalizarTexto(item?.brand || "");
    const marca = normalizarTexto(marcaActiva || "");

    if (!itemBrand || itemBrand === "all") return true;
    if (!marca) return false;

    return itemBrand === marca;
  };

  const agIdActivo = useMemo(() => {
    return String(selectedMailData?.ag_id || "").trim();
  }, [selectedMailData?.ag_id]);

  const marcaActiva = useMemo(() => {
    return String(selectedMailData?.marca_vehiculo || "").trim();
  }, [selectedMailData?.marca_vehiculo]);

  const getNombreAsesorActual = () => {
    const posiblesValores = [
      localStorage.getItem("nombreAsesor"),
      localStorage.getItem("asesorNombre"),
      localStorage.getItem("userName"),
      localStorage.getItem("nombre"),
      localStorage.getItem("name"),
      localStorage.getItem("userEmail"),
    ];

    return (
      posiblesValores.find((valor) => valor && valor.trim() !== "")?.trim() ||
      "Sin nombre"
    );
  };

  const limpiarTituloAccesorio = (title = "") => title.split(" - ")[0].trim();

  const recalcularTotalesPlan = (plan) => {
    const accessoriesOriginales = Array.isArray(plan?.accessories)
      ? plan.accessories
      : [];

    const totalBaseSinDescuento = accessoriesOriginales.reduce(
      (sum, item) => sum + Number(item.price_base ?? item.price ?? 0),
      0,
    );

    const aplicaDescuento = totalBaseSinDescuento > 15000;

    const accessories = accessoriesOriginales.map((item) => {
      const priceBase = Number(item.price_base ?? item.price ?? 0);
      const priceConDescuento = aplicaDescuento
        ? Math.round(priceBase * 0.9 * 100) / 100
        : priceBase;

      return {
        ...item,
        price_base: priceBase,
        price_promo: priceConDescuento,
        price: priceConDescuento,
      };
    });

    const totalPrice = accessories.reduce(
      (sum, item) => sum + Number(item.price || 0),
      0,
    );

    const totalPricePromo = accessories.reduce(
      (sum, item) => sum + Number(item.price_promo ?? item.price ?? 0),
      0,
    );

    const totalPriceBase = accessories.reduce(
      (sum, item) => sum + Number(item.price_base ?? item.price ?? 0),
      0,
    );

    return {
      ...plan,
      accessories,
      totalPrice,
      totalPrice_promo: totalPricePromo,
      totalPrice_base: totalPriceBase,
    };
  };

  const LIMITE_DESCUENTO = 15000;

  const totalBasePaquete = Number(planSeleccionadoState?.totalPrice_base || 0);

  const faltaParaDescuento = Math.max(0, LIMITE_DESCUENTO - totalBasePaquete);

  const aplicaDescuentoPaquete = totalBasePaquete > LIMITE_DESCUENTO;

  const esPlanElite = (plan) => normalizar(plan?.title || "") === "elite";

  // Función para obtener los datos desde la API
  const fetchData = async () => {
    setLoading(true); // Activar el loader

    try {
      const agenciasStorage = JSON.parse(localStorage.getItem("agencias")); // Recuperar agencias del localStorage
      const modulos = JSON.parse(localStorage.getItem("modulos")); // Recuperar los módulos del localStorage
      const userId = localStorage.getItem("userId"); // Obtener el userId desde el localStorage

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_token: accessToken,
          modulos, // Envía los módulos
          usuario_id: userId, // Envía el user_id
          agencias: agenciasStorage, // Envía las agencias
          // Otros filtros
          ...filters,
        }),
      });

      const data = await response.json();
      console.log("Respuesta de la API:", data); // Log para depuración

      if (data.statusCode === 200) {
        // Verifica si hay resultados y asigna correctamente a mailData
        if (
          Array.isArray(data.data.resultados) &&
          data.data.resultados.length > 0
        ) {
          // Procesar los datos
          const processedData = data.data.resultados.map((cliente) => {
            let productos = [];

            if (
              cliente.plan_accesorios &&
              cliente.plan_accesorios !== '"null"'
            ) {
              let accesorioString;

              try {
                // Intentamos parsear la primera vez
                accesorioString = JSON.parse(cliente.plan_accesorios);
              } catch {
                // Si falla, asumimos que no es un JSON válido y lo dejamos como está
                accesorioString = cliente.plan_accesorios;
              }

              // Verificamos si el resultado puede ser un string JSON anidado
              if (typeof accesorioString === "string") {
                try {
                  // Intentamos parsear nuevamente si es necesario
                  accesorioString = JSON.parse(accesorioString);
                } catch {
                  // Si falla, dejamos el accesorio como un array vacío para evitar errores
                  accesorioString = [];
                }
              }

              // Convertimos a array si no lo es ya
              productos = Array.isArray(accesorioString)
                ? accesorioString
                : [accesorioString];
            }

            return {
              ...cliente,
              nombre_completo: getNombreCompleto(cliente),
              productos, // Añadir los productos procesados al cliente
            };
          });

          setMailData(processedData);
        } else {
          console.error("No hay registros disponibles.");
          // No hay resultados, se asigna un arreglo vacío
          setMailData([]);
          setSelectedMailData(null);

          Swal.fire({
            icon: "warning",
            title: "Sin resultados",
            text: "No se encontraron resultados para los filtros aplicados.",
          });
        }
      } else if (data.statusCode === 404) {
        // No hay resultados, se asigna un arreglo vacío
        setMailData([]);
        setSelectedMailData(null);
        // Mostrar alerta si el statusCode es 404
        Swal.fire({
          icon: "warning",
          title: "Sin resultados",
          text: "No se encontraron resultados para los filtros aplicados.",
        });
      } else {
        // No hay resultados, se asigna un arreglo vacío
        setMailData([]);
        setSelectedMailData(null);
        console.error(
          "Error al obtener los datos:",
          data.message || "Sin mensaje de error.",
        );
      }
    } catch (error) {
      // No hay resultados, se asigna un arreglo vacío
      setMailData([]);
      setSelectedMailData(null);
      console.error("Error en la solicitud:", error);
    } finally {
      setLoading(false); // Desactivar el loader una vez que se termine la solicitud
    }
  };

  // Función para obtener las opciones de filtro desde la API
  const fetchFilterOptions = async () => {
    setLoading(true); // Activar el loader

    try {
      const agenciasStorage = JSON.parse(localStorage.getItem("agencias")); // Recuperar agencias del localStorage
      const modulos = JSON.parse(localStorage.getItem("modulos")); // Recuperar los módulos del localStorage
      const userId = localStorage.getItem("userId"); // Obtener el userId desde el localStorage

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_token: accessToken,
          modulos, // Envía los módulos
          usuario_id: userId, // Envía el user_id
          agencias: agenciasStorage, // Envía las agencias
        }),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        const opciones = data.data?.opciones || {};
        const resultados = Array.isArray(data.data?.resultados)
          ? data.data.resultados
          : [];

        const nombresCompletos = [
          ...resultados.map((cliente) => getNombreCompleto(cliente)),
          ...(Array.isArray(opciones.nombre)
            ? opciones.nombre.map((item) =>
                typeof item === "object"
                  ? getNombreCompleto(item)
                  : String(item || "").trim(),
              )
            : []),
        ]
          .filter(Boolean)
          .filter(
            (nombre, index, arreglo) =>
              arreglo.findIndex(
                (item) => normalizarTexto(item) === normalizarTexto(nombre),
              ) === index,
          )
          .sort((a, b) => a.localeCompare(b, "es", { sensitivity: "base" }));

        if (opciones && Object.keys(opciones).length > 0) {
          setFilterOptions({
            ...opciones,
            nombre: nombresCompletos,
          });
        } else {
          // Si no hay opciones disponibles, mostrar alerta
          Swal.fire({
            icon: "warning",
            title: "Sin opciones",
            text: "No se encontraron opciones para los filtros.",
          });
        }
      } else if (data.statusCode === 404) {
        // Si el statusCode es 404, mostrar alerta de "sin resultados"
        Swal.fire({
          icon: "warning",
          title: "Sin resultados",
          text: "No se encontraron opciones para los filtros.",
        });
      } else {
        console.error(
          "Error al obtener las opciones de filtro:",
          data.message || "Sin mensaje de error.",
        );
      }
    } catch (error) {
      console.error("Error al obtener las opciones de filtro:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al obtener las opciones de filtro.",
      });
    } finally {
      setLoading(false); // Desactivar el loader una vez que termine la solicitud
    }
  };

  // Función para actualizar los datos en la API
  const updateData = async (clienteId, estado) => {
    setLoading(true); // Activar el loader

    try {
      // Crear un objeto con los valores de todos los estados
      const estadoUpdate = {
        proceso: estado === "proceso" ? 1 : 0,
        aprobado: estado === "aprobado" ? 1 : 0,
        rechazado: estado === "rechazado" ? 1 : 0,
        condicionado: estado === "condicionado" ? 1 : 0,
        evaluacion: estado === "evaluacion" ? 1 : 0,
        complementos_sol: estado === "complementos_sol" ? 1 : 0,
        reexpedicion: estado === "reexpedicion" ? 1 : 0,
        preformalizacion: estado === "preformalizacion" ? 1 : 0,
      };

      const updatePayload = {
        access_token: accessToken,
        id: clienteId, // ID del cliente que deseas actualizar
        estado: estadoUpdate, // Enviar el objeto con los estados
      };

      const response = await fetch(apiUrlUpdate, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatePayload),
      });

      const data = await response.json();
      console.log("Respuesta de la API:", data);

      if (data.statusCode === 200) {
        // Si la actualización fue exitosa, actualizar el estado de la aplicación
        Swal.fire({
          icon: "success",
          title: "Actualización exitosa",
          text: "El estado del cliente ha sido actualizado.",
        });
        fetchData(); // Vuelve a obtener los datos actualizados
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo actualizar el estado del cliente.",
        });
      }
    } catch (error) {
      console.error("Error en la solicitud de actualización:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al intentar actualizar el estado.",
      });
    } finally {
      setLoading(false); // Desactivar el loader
    }
  };

  const updateDataFormalizado = async (clienteId, estado) => {
    setLoading(true); // Activar el loader

    try {
      // Crear un objeto con los valores de todos los estados
      const estadoUpdate = {
        formalizado: estado === "formalizado" ? 1 : 0,
        no_formalizado: estado === "no_formalizado" ? 1 : 0,
        proceso: estado === "proceso" ? 1 : 0,
      };

      const updatePayload = {
        access_token: accessToken,
        id: clienteId, // ID del cliente que deseas actualizar
        estado: estadoUpdate, // Enviar el objeto con los estados
      };

      const response = await fetch(apiUrlUpdateFormalizado, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatePayload),
      });

      const data = await response.json();
      console.log("Respuesta de la API:", data);

      if (data.statusCode === 200) {
        // Si la actualización fue exitosa, actualizar el estado de la aplicación
        Swal.fire({
          icon: "success",
          title: "Actualización exitosa",
          text: "El estado del cliente ha sido actualizado.",
        });
        fetchData(); // Vuelve a obtener los datos actualizados
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo actualizar el estado del cliente.",
        });
      }
    } catch (error) {
      console.error("Error en la solicitud de actualización:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al intentar actualizar el estado.",
      });
    } finally {
      setLoading(false); // Desactivar el loader
    }
  };

  const updateDataStatus = async (clienteId, newStatus) => {
    setLoading(true);

    try {
      const userId = localStorage.getItem("userId");
      const nombreAsesor = getNombreAsesorActual();

      const updatePayload = {
        access_token: accessToken,
        id: clienteId,
        status: newStatus,
        id_usuario: userId,
        nombre_asesor: nombreAsesor,
      };

      const response = await fetch(apiUrlUpdateStatus, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatePayload),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Actualización exitosa",
          text: "El status del cliente ha sido actualizado.",
        });

        if (selectedMailData?.depente_auto === "No") {
          await updateSubStatus(clienteId, "Sin substatus");
        }

        fetchData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "No se pudo actualizar el status del cliente.",
        });
      }
    } catch (error) {
      console.error("Error en la solicitud de actualización:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al intentar actualizar el status.",
      });
    } finally {
      setLoading(false);
    }
  };

  const updateSubStatus = async (clienteId, newSubStatus) => {
    setLoading(true);

    try {
      const userId = localStorage.getItem("userId");
      const nombreAsesor = getNombreAsesorActual();

      const updatePayload = {
        access_token: accessToken,
        id: clienteId,
        sub_status: newSubStatus,
        id_usuario: userId,
        nombre_asesor: nombreAsesor,
      };

      const response = await fetch(apiUrlUpdateSubStatus, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatePayload),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Actualización exitosa",
          text: "El sub-status del cliente ha sido actualizado.",
        });
        fetchData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            data.message || "No se pudo actualizar el sub-status del cliente.",
        });
      }
    } catch (error) {
      console.error("Error en la solicitud de actualización:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al intentar actualizar el sub-status.",
      });
    } finally {
      setLoading(false);
    }
  };

  const bankOptions = [
    { label: "NR Finance", value: "nr_finance" },
    { label: "Banorte", value: "banorte" },
    { label: "Scotiabank", value: "scotiabank" },
    { label: "Santander", value: "santander" },
    { label: "Cibanco", value: "cibanco" },
    { label: "Sicrea", value: "sicrea" },
    { label: "BBVA", value: "bbva" },
    { label: "Hey Banco", value: "hey_banco" },
    { label: "HSBC", value: "hsbc" },
    { label: "Cetelem", value: "cetelem" },
    { label: "VWSF", value: "vwfs" },
    { label: "Seat SF", value: "seat_sf" },
    { label: "Cupra SF", value: "cupra_sf" },
    { label: "Kuna", value: "kuna" },
    { label: "Mstar", value: "mstar" },
    { label: "Credito GO", value: "credito_go" },
    { label: "FinanMadrid", value: "finanmadrid" },
    { label: "Nexu", value: "nexu" },
  ];

  const bankKeyByLabel = React.useMemo(() => {
    const map = {};
    for (const { label, value } of bankOptions) map[label] = value;
    return map;
  }, [bankOptions]);

  const bankFlags = bankOptions.map((o) => o.value);

  const currentFinancieraValue = React.useMemo(() => {
    const label = (selectedMailData?.financiera || "").trim();
    if (label && bankKeyByLabel[label]) return bankKeyByLabel[label];

    for (const flag of bankFlags) {
      if (Number(selectedMailData?.[flag]) === 1) return flag;
    }
    return "";
  }, [selectedMailData, bankKeyByLabel]);

  const apiUrlUpdateFinanciera =
    "https://api.checkmark.mx/solicitudes/actualizar/financiera";

  const updateFinanciera = async (clienteId, financieraValue) => {
    setLoading(true);
    try {
      const payload = {
        access_token: accessToken,
        id: clienteId,
        financiera: financieraValue,
      };
      const resp = await fetch(apiUrlUpdateFinanciera, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await resp.json();

      if (data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Financiera actualizada",
          text: "Se guardó correctamente.",
        });
        fetchData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "No se pudo actualizar.",
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar.",
      });
    } finally {
      setLoading(false);
    }
  };

  const apiUrlUploadDocumento =
    "https://api.checkmark.mx/solicitudes/actualizar/documento";

  const obtenerTokenOpenIA = async () => {
    const formData = new FormData();

    formData.append(
      "access_token",
      "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3",
    );

    const res = await fetch("https://api.checkmark.mx/obtener/token/openia", {
      method: "POST",
      body: formData,
    });

    const data = await res.json();

    if (!res.ok || data.statusCode !== 200) {
      throw new Error(data.message || "No se pudo obtener el token de OpenIA");
    }

    const tokenOpenIA = data?.data?.token_openia?.access_token;

    if (!tokenOpenIA) {
      throw new Error("El servicio no devolvió access_token de OpenIA");
    }

    return tokenOpenIA;
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setLoading(true);
    setSelectedFile(file);

    try {
      // 1) OCR
      const formDataOCR = new FormData();
      formDataOCR.append("apikey", "DPD8VZYKE82MX"); // considera mover la key al backend
      formDataOCR.append("file", file);
      formDataOCR.append("language", "spa");

      const ocrRes = await fetch("https://apipro1.ocr.space/parse/image", {
        method: "POST",
        body: formDataOCR,
      });
      const ocrJson = await ocrRes.json();

      const rawText = ocrJson?.ParsedResults?.[0]?.ParsedText || "";
      const textFormateado = quitarAcentos(rawText);
      const t = textFormateado.replace(/(\r\n|\n|\r)/g, " ").trim();

      const tokenOpenIA = await obtenerTokenOpenIA();

      // 2) OpenAI para extraer datos
      const openaiRes = await fetch(
        "https://api.openai.com/v1/chat/completions",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${tokenOpenIA}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            model: "gpt-4o-mini",
            max_tokens: 1000,
            temperature: 0.1,
            messages: [
              {
                role: "user",
                content:
                  "Genera SOLO un JSON válido con un objeto 'datos' que contenga: Marca, Año, Modelo, Version, Cliente, Telefono, Precio total, PlazoMeses, Enganche, Banco, TipoDeVehiculo, PlanDeFinanciamiento, TazaDeInteres, Correo, Agencia, Distribuidor. Texto: " +
                  t,
              },
            ],
          }),
        },
      );

      const openaiData = await openaiRes.json();
      const contenidoModelo =
        openaiData?.choices?.[0]?.message?.content || "{}";

      // 3) Parseo robusto del JSON
      let parsed = {};
      try {
        const match = contenidoModelo.match(/\{[\s\S]*\}/);
        parsed = JSON.parse(match ? match[0] : contenidoModelo);
      } catch {
        console.warn(
          "No se pudo parsear JSON de OpenAI, continuo sin nombre propuesto.",
        );
        parsed = {};
      }

      const nombreDetectado = parsed?.datos?.Cliente?.toString().trim() || "";
      const nombreActual = getNombreCompleto(selectedMailData);

      // 3.1) Confirmación de nombre (apaga loader antes del Swal)
      let nombreAEnviar = "";
      if (
        nombreDetectado &&
        nombreDetectado.length >= 3 &&
        nombreDetectado !== nombreActual
      ) {
        setLoading(false); // <- para que el overlay no tape el modal

        const { isConfirmed } = await Swal.fire({
          icon: "question",
          title: "¿Actualizar nombre del cliente?",
          html: `
            <div class="text-start">
              <div><strong>Detectado:</strong> ${nombreDetectado}</div>
              <div><strong>Actual:</strong> ${nombreActual || "(vacío)"}</div>
              <div class="mt-2 small black-text text-muted">Este cambio actualizará los campos <code>nombre</code> y <code>apellido_paterno</code> de la solicitud.</div>
            </div>
          `,
          showCancelButton: true,
          confirmButtonText: "Sí, actualizar",
          cancelButtonText: "No, mantener",
          allowOutsideClick: false,
        });

        if (isConfirmed) nombreAEnviar = nombreDetectado;

        setLoading(true); // <- volvemos a encender para la subida
      }

      // 4) Subir documento (multipart/form-data)
      const formDataUp = new FormData();
      formDataUp.append("access_token", accessToken);
      formDataUp.append("id", selectedMailData.id);
      formDataUp.append("documento", file);
      if (nombreAEnviar) {
        const nombreSeparado = separarNombreCompleto(nombreAEnviar);
        formDataUp.append("nombre", nombreSeparado.nombre);
        formDataUp.append(
          "apellido_paterno",
          nombreSeparado.apellido_paterno,
        );
      }

      const uploadRes = await fetch(apiUrlUploadDocumento, {
        method: "POST",
        body: formDataUp,
      });
      const uploadJson = await uploadRes.json();

      // Apaga loader antes de mostrar el Swal final
      setLoading(false);

      if (uploadJson.statusCode === 200) {
        await Swal.fire({
          icon: "success",
          title: "Documento actualizado",
          text: nombreAEnviar
            ? "Se guardó el documento y se actualizó el nombre."
            : "Se guardó el documento.",
        });
        setLoading(true);
        await fetchData();
        setLoading(false);
      } else {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: uploadJson.message || "No se pudo actualizar el documento.",
        });
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error durante el escaneo o la carga.",
      });
    } finally {
      setLoading(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const apiUrlHistorial = "https://api.checkmark.mx/solicitudes/historial?id=";

  const verHistorial = async (id) => {
    try {
      setLoading(true);
      const resp = await fetch(`${apiUrlHistorial}${id}`);
      const data = await resp.json();

      const rows = Array.isArray(data?.data) ? data.data : [];
      // const rows = [...rows].reverse(); // opcional: más reciente primero

      const html = rows.length
        ? `
        <style>
          .hist-wrap { max-height: 360px; overflow: auto; }
          .hist-table { min-width: 900px; }
          .hist-table th, .hist-table td {
            padding: .5rem .75rem;
            vertical-align: middle;
            white-space: nowrap;
          }
          .hist-table td.valor {
            white-space: normal;
            word-break: break-word;
          }
        </style>

        <div class="black-text hist-wrap">
          <table class="table table-sm table-striped table-hover black-text hist-table">
           <thead>
  <tr>
    <th class="black-text">Fecha</th>
    <th class="black-text">Campo</th>
    <th class="black-text">Valor anterior</th>
    <th class="black-text">Valor nuevo</th>
    <th class="black-text">Asesor</th>
  </tr>
</thead>
<tbody>
  ${rows
    .map(
      (r) => `
    <tr>
      <td class="black-text">${r.fecha || ""}</td>
      <td class="black-text">${r.campo || ""}</td>
      <td class="black-text valor">${r.valor_anterior || ""}</td>
      <td class="black-text valor">${r.valor_nuevo || ""}</td>
      <td class="black-text">${r.nombre_asesor || r.asesor || r.id_usuario || ""}</td>
    </tr>
  `,
    )
    .join("")}
</tbody>
          </table>
        </div>`
        : `<div class="text-muted black-text">No hay movimientos registrados.</div>`;

      setLoading(false);
      await Swal.fire({
        icon: "info",
        title: "Histórico de cambios",
        html,
        width: 950,
        confirmButtonText: "Cerrar",
      });
    } catch (error) {
      console.error("Error al obtener historial:", error);
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo obtener el histórico.",
      });
    }
  };

  const apiUrlHistorialFinanciera =
    "https://api.checkmark.mx/solicitudes/historial/financiera?id=";

  const verHistorialFinanciera = async (id) => {
    try {
      setLoading(true);
      const resp = await fetch(`${apiUrlHistorialFinanciera}${id}`);
      const data = await resp.json();
      const rows = data?.data || [];
      // const rows = [...(data?.data || [])].reverse(); // opcional: más reciente primero

      const html = rows.length
        ? `
        <style>
          /* Contenedor con scroll vertical + horizontal si hace falta */
          .hist-wrap { max-height: 360px; overflow: auto; }
          /* La tabla pide ancho mínimo, así no “rompe” el texto vertical */
          .hist-table { min-width: 1050px; }
          .hist-table th, .hist-table td { 
            padding: .5rem .75rem; 
            vertical-align: middle; 
            white-space: nowrap; /* no romper por defecto */
          }
          /* Solo estas columnas pueden partirse */
          .hist-table td.desc { white-space: normal; }
          .hist-table td.mail { white-space: normal; word-break: break-all; }
        </style>

        <div class="black-text hist-wrap">
          <table class="table table-sm table-striped table-hover black-text hist-table">
            <thead>
              <tr>
                <th class="black-text">Fecha</th>
                <th class="black-text">Campo</th>
                <th class="black-text">Descripción</th>
                <th class="black-text">Nombre</th>
                <th class="black-text">Teléfono</th>
                <th class="black-text">Correo</th>
                <th class="black-text">Financiera</th>
              </tr>
            </thead>
            <tbody>
              ${rows
                .map(
                  (r) => `
                <tr>
                  <td class="black-text">${r.fecha || ""}</td>
                  <td class="black-text">${r.campo || ""}</td>
                  <td class="black-text desc">${r.descripcion || ""}</td>
                  <td class="black-text">${getNombreCompleto(r) || ""}</td>
                  <td class="black-text">${r.telefono || ""}</td>
                  <td class="black-text mail">${r.correo_electronico || ""}</td>
                  <td class="black-text">${r.financiera || ""}</td>
                </tr>
              `,
                )
                .join("")}
            </tbody>
          </table>
        </div>`
        : `<div class="text-muted black-text">No hay movimientos registrados.</div>`;

      setLoading(false);
      await Swal.fire({
        icon: "info",
        title: "Histórico de cambios",
        html,
        width: 1000, // un poco más ancho ayuda
        confirmButtonText: "Cerrar",
      });
    } catch {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo obtener el histórico.",
      });
    }
  };

  const apiUrlUpdateComentario =
    "https://api.checkmark.mx/solicitudes/actualizar/comentario";

  const guardarComentario = async (clienteId, comentario) => {
    setLoading(true);

    try {
      const userId = localStorage.getItem("userId");
      const nombreAsesor = getNombreAsesorActual();

      const payload = {
        access_token: accessToken,
        id: clienteId,
        comentario,
        id_usuario: userId,
        nombre_asesor: nombreAsesor,
      };

      const response = await fetch(apiUrlUpdateComentario, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      setLoading(false);

      if (data.statusCode === 200) {
        await Swal.fire({
          icon: "success",
          title: "Comentario guardado",
          text: "Se agregó correctamente.",
        });

        fetchData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "No se pudo guardar el comentario.",
        });
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al guardar el comentario.",
      });
    }
  };

  const apiUrlComentarios =
    "https://api.checkmark.mx/solicitudes/comentarios?id=";

  const verComentarios = async (id) => {
    try {
      setLoading(true);

      const resp = await fetch(`${apiUrlComentarios}${id}`);
      const data = await resp.json();
      const rows = Array.isArray(data?.data) ? [...data.data].reverse() : [];

      const html = rows.length
        ? `
        <style>
          .hist-wrap { max-height: 360px; overflow: auto; }
          .hist-table { min-width: 850px; }
          .hist-table th, .hist-table td {
            padding: .5rem .75rem;
            vertical-align: middle;
          }
          .hist-table td.comentario {
            white-space: normal;
            word-break: break-word;
            min-width: 350px;
          }
        </style>

        <div class="black-text hist-wrap">
          <table class="table table-sm table-striped table-hover black-text hist-table">
           <thead>
  <tr>
    <th class="black-text">Fecha</th>
    <th class="black-text">Comentario</th>
    <th class="black-text">Asesor</th>
  </tr>
</thead>
<tbody>
  ${rows
    .map(
      (r) => `
    <tr>
      <td class="black-text">${r.fecha || ""}</td>
      <td class="black-text comentario">${r.comentario || ""}</td>
      <td class="black-text">${r.nombre_asesor || r.asesor || r.id_usuario || ""}</td>
    </tr>
  `,
    )
    .join("")}
</tbody>
          </table>
        </div>`
        : `<div class="text-muted black-text">No hay comentarios registrados.</div>`;

      setLoading(false);

      await Swal.fire({
        icon: "info",
        title: "Historial de comentarios",
        html,
        width: 900,
        confirmButtonText: "Cerrar",
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo obtener el historial de comentarios.",
      });
    }
  };

  const abrirModalComentario = async (clienteId) => {
    const { value: comentario } = await Swal.fire({
      title: "Agregar comentario",
      input: "textarea",
      inputLabel: "Escribe un comentario",
      inputPlaceholder: "Ej. Cliente pide seguimiento mañana...",
      inputAttributes: {
        "aria-label": "Escribe un comentario",
      },
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return "Debes escribir un comentario";
        }
        if (value.trim().length < 3) {
          return "El comentario es muy corto";
        }
        return null;
      },
    });

    if (comentario && comentario.trim()) {
      await guardarComentario(clienteId, comentario.trim());
    }
  };

  const marcarVentaIncompleta = async (venta) => {
    if (!venta?.id) return;

    const { isConfirmed } = await Swal.fire({
      icon: "warning",
      title: "¿Marcar solicitud como incompleta?",
      html: `
      <div class="black-text text-start">
        <p>Esta acción cambiará el campo <strong>activo</strong> a <strong>Incompleto</strong>.</p>
        <p class="mb-0"><strong>Folio:</strong> ${venta.folio_venta || ""}</p>
        <p class="mb-0"><strong>Cliente:</strong> ${getNombreCompleto(venta) || ""}</p>
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: "Sí, marcar incompleta",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#dc3545",
      reverseButtons: true,
    });

    if (!isConfirmed) return;

    setLoading(true);

    try {
      const response = await fetch(apiUrlMarcarIncompleto, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          venta_id: venta.id,
          activo: "Incompleto",
        }),
      });

      const data = await response.json();

      if (response.ok && data.status === "success") {
        // Apagamos el loader ANTES de mostrar el Swal
        setLoading(false);

        await Swal.fire({
          icon: "success",
          title: "Solicitud actualizada",
          text: data.message || "La solicitud se marcó como incompleta.",
          confirmButtonText: "OK",
        });

        // Quitamos visualmente el registro sin esperar otra consulta
        setMailData((prev) =>
          prev.filter((registro) => Number(registro.id) !== Number(venta.id)),
        );

        setSelectedMailData(null);

        // Ahora sí refrescamos datos
        setLoading(true);
        await fetchData();
        await fetchFilterOptions();
        setLoading(false);
      } else {
        setLoading(false);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "No se pudo marcar como incompleta.",
        });
      }
    } catch (error) {
      console.error("Error al marcar como incompleta:", error);

      setLoading(false);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al intentar marcar la solicitud como incompleta.",
      });
    } finally {
      setLoading(false);
    }
  };

  // Llama a `fetchData` y `fetchFilterOptions` cuando se monte el componente
  useEffect(() => {
    fetchData();
    fetchFilterOptions();
  }, [filters]); // Llamar a fetchData cuando los filtros cambian

  useEffect(() => {
    if (!selectedMailData?.id || !agIdActivo || !marcaActiva) {
      setTableData([]);
      return;
    }

    const requestId = ++inventarioRequestIdRef.current;
    const controller = new AbortController();

    const requestData = {
      access_token: accessToken,
      marca: marcaActiva,
      ag_id: agIdActivo,
    };

    fetch(apiUrlInventario, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
      signal: controller.signal,
    })
      .then((res) => res.json())
      .then((data) => {
        if (requestId !== inventarioRequestIdRef.current) return;

        const foodOriginal = Array.isArray(data?.food) ? data.food : [];

        const foodFiltrado = foodOriginal.filter((item) => {
          const itemType = normalizarTexto(item?.type || "");

          if (itemType === "accesorios" || itemType === "garantias") {
            return (
              !item?.hide &&
              estaDisponible(item) &&
              coincideMarcaItem(item, marcaActiva) &&
              coincideAgenciaItem(item, agIdActivo)
            );
          }

          return true;
        });

        const dataLimpia = {
          ...data,
          food: foodFiltrado,
        };

        setTableData(dataLimpia);
        console.log("Payload inventario solicitudes:", requestData);
        console.log("Datos recibidos por inventario filtrados:", dataLimpia);
      })
      .catch((error) => {
        if (error?.name === "AbortError") return;
        console.error("Error al consumir la API de inventario:", error);
        setTableData([]);
      });

    return () => {
      controller.abort();
    };
  }, [selectedMailData?.id, agIdActivo, marcaActiva]);

  var dateRange = {
    currentWeek:
      Moment().subtract(7, "days").format("D MMM YYYY") +
      " - " +
      Moment().format("D MMM YYYY"),
    prevWeek:
      Moment().subtract(15, "days").format("D MMM") +
      " - " +
      Moment().subtract(8, "days").format("D MMM YYYY"),
  };

  const handleDateApplyEvent = (event, picker) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      startDate: picker.startDate.format("YYYY-MM-DD"),
      endDate: picker.endDate.format("YYYY-MM-DD"),
    }));
  };

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const cancelButton = document.querySelector(".cancelBtn");
      const applyButton = document.querySelector(".applyBtn");

      // Solo cambiar el texto si no es el valor correcto
      if (cancelButton && cancelButton.textContent !== "Cancelar") {
        cancelButton.textContent = "Cancelar";
      }
      if (applyButton && applyButton.textContent !== "Aplicar") {
        applyButton.textContent = "Aplicar";
      }
    });

    const targetNode = document.body;
    observer.observe(targetNode, { childList: true, subtree: true });

    return () => observer.disconnect(); // Limpiar observador al desmontar
  }, []);

  useEffect(() => {
    if (mailData.length > 0 && selectedMailData) {
      const updatedClient = mailData.find(
        (cliente) => cliente.id === selectedMailData.id,
      );
      setSelectedMailData(updatedClient || null);
    }
  }, [mailData]);

  useEffect(() => {
    if (!selectedMailData) {
      setDatosReporteForm(construirDatosReporteForm({}));
      setEditandoDatosReporte(false);
      return;
    }

    setDatosReporteForm(construirDatosReporteForm(selectedMailData));
    setEditandoDatosReporte(false);
  }, [selectedMailData?.id]);

  useEffect(() => {
    if (!selectedMailData) {
      setPlanesFinanciamientoState([]);
      setPlanSeleccionadoState(null);
      return;
    }

    const parsedPlanes = parseJsonSeguro(
      selectedMailData?.planes_financiamiento,
      [],
    );

    setPlanesFinanciamientoState(parsedPlanes);

    const selectedPlan =
      parsedPlanes.find((plan) => plan.isSelected === true) || null;

    setPlanSeleccionadoState(selectedPlan);
  }, [selectedMailData]);

  const marcaSeleccionada = useMemo(
    () => normalizarTexto(marcaActiva || ""),
    [marcaActiva],
  );

  const filteredAccessoriesAndWarranties = useMemo(() => {
    const tipoAuto = normalizarTexto(selectedMailData?.tipo_auto || "");
    const modeloAuto = normalizarTexto(selectedMailData?.modelo_vehiculo || "");
    const versionAuto = normalizarTexto(
      selectedMailData?.version_vehiculo || "",
    );
    const marcaActual = marcaSeleccionada || normalizarTexto(marcaActiva || "");
    const agActual = agIdActivo || selectedMailData?.ag_id || "";

    const soloParaNuevos = [
      "Garantía Extendida",
      "Cobertura de Llaves",
      "Canastilla de techo",
      "Rejilla Separadora",
      "Tapete uso rudo area de carga",
      "Organizador de Cajuela",
      "Seguro LLantas",
    ];
    const soloParaNuevosNorm = soloParaNuevos.map(normalizarTexto);

    const soloParaSeminuevos = ["Kit de seguridad", "Localizador Gocar"];
    const soloParaSeminuevosNorm = soloParaSeminuevos.map(normalizarTexto);

    const esNuevo = tipoAuto === "nuevos" || tipoAuto === "nuevo";
    const esSeminuevo = tipoAuto === "seminuevos" || tipoAuto === "seminuevo";

    const actuales = new Set(
      (planSeleccionadoState?.accessories || []).map((acc) =>
        normalizarTexto(limpiarTituloAccesorio(acc.title)),
      ),
    );

    const food = Array.isArray(tableData?.food) ? tableData.food : [];

    const filtered = food
      .filter((item) => {
        if (!estaDisponible(item)) return null;
        if (!coincideMarcaItem(item, marcaActual)) return null;
        if (!coincideAgenciaItem(item, agActual)) return null;

        const itemType = normalizarTexto(item.type || "");
        const esGarantia = itemType === "garantias";
        const esAccesorio = itemType === "accesorios";
        const itemTitle = item.title || "";
        const tituloNorm = normalizarTexto(itemTitle);
        const itemBrandNorm = normalizarTexto(item.brand || "");
        const itemAgIdNorm = normalizarTexto(item.ag_id || "");
        const esBrandAll = itemBrandNorm === "all";
        const esAgIdGlobal = !itemAgIdNorm || itemAgIdNorm === "all";
        const esGlobalAll = esBrandAll && esAgIdGlobal;

        const isAccessoryOrWarranty = esAccesorio || esGarantia;

        if (!isAccessoryOrWarranty) {
          return null;
        }

        const esProteccion5000 =
          esGarantia &&
          tituloNorm.includes("proteccion de llanta-rin") &&
          tituloNorm.includes("5,000");

        const esProteccion12000 =
          esGarantia &&
          tituloNorm.includes("proteccion de llanta-rin") &&
          tituloNorm.includes("12,000");

        if (esSeminuevo && (esProteccion5000 || esProteccion12000)) {
          return null;
        }

        const esGarantiaMecanica =
          tituloNorm.includes("garantia mecanica") ||
          tituloNorm.includes("garantía mecánica") ||
          tituloNorm.includes("mecanica amplia");

        if (esNuevo && esGarantiaMecanica) return null;

        const esSoloSeminuevos = soloParaSeminuevosNorm.some((palabra) =>
          tituloNorm.includes(palabra),
        );
        if (esNuevo && esSoloSeminuevos) return null;

        const esSoloParaNuevos = soloParaNuevosNorm.some((palabra) =>
          tituloNorm.includes(palabra),
        );
        if (esSeminuevo && esSoloParaNuevos) return null;

        let finalTitle = itemTitle;

        if (itemTitle.includes(" - ")) {
          const [baseTitle, rawModelos = ""] = itemTitle.split(" - ");

          const modelosListaAccesorio = rawModelos
            .split(",")
            .map((m) => normalizarTexto(m))
            .filter(Boolean);

          const modelosListaGarantia = rawModelos
            .split(",")
            .map((m) => limpiarModeloVersion(m))
            .filter(Boolean);

          const incluyeTodos =
            modelosListaAccesorio.includes("todos") ||
            modelosListaGarantia.includes("todos");

          let coincide = false;

          if (esGarantia) {
            const modeloLimpio = limpiarModeloVersion(modeloAuto);
            const versionLimpia = limpiarModeloVersion(versionAuto);
            const modeloVersion = limpiarModeloVersion(
              `${modeloLimpio} ${versionLimpia}`,
            );

            const coincideSoloModelo =
              !!modeloLimpio && modelosListaGarantia.includes(modeloLimpio);

            const coincideModeloVersion =
              !!modeloVersion && modelosListaGarantia.includes(modeloVersion);

            coincide = coincideSoloModelo || coincideModeloVersion;
          } else {
            coincide =
              !!modeloAuto && modelosListaAccesorio.includes(modeloAuto);
          }

          if (incluyeTodos || coincide || esGlobalAll) {
            finalTitle = baseTitle;
          } else {
            return null;
          }
        } else {
          const esUniversal = tituloNorm.includes("todos") || esGlobalAll;
          const mencionaMiModelo = modeloAuto
            ? incluyePalabra(tituloNorm, modeloAuto)
            : false;

          if (!esUniversal && !mencionaMiModelo) {
            return null;
          }
        }

        const titleNormalizado = normalizarTexto(finalTitle);

        if (actuales.has(titleNormalizado)) {
          return null;
        }

        return {
          ...item,
          title: finalTitle.split(" - ")[0].trim(),
          price: Number(item.price || item.price_promo || item.price_base || 0),
          price_promo: Number(item.price_promo ?? item.price ?? 0),
          price_base: Number(item.price_base ?? item.price ?? 0),
        };
      })
      .filter(Boolean);

    return filtered;
  }, [
    tableData?.food,
    marcaSeleccionada,
    marcaActiva,
    agIdActivo,
    selectedMailData?.ag_id,
    selectedMailData?.tipo_auto,
    selectedMailData?.modelo_vehiculo,
    selectedMailData?.version_vehiculo,
    planSeleccionadoState,
  ]);

  const addAccessoryToSelectedPlan = (item) => {
    if (!planSeleccionadoState) return;

    if (esPlanElite(planSeleccionadoState)) {
      Swal.fire({
        icon: "warning",
        title: "Paquete bloqueado",
        text: "El paquete Elite no permite modificaciones.",
      });
      return;
    }

    const yaExiste = (planSeleccionadoState.accessories || []).some(
      (acc) => normalizar(acc.title) === normalizar(item.title),
    );

    if (yaExiste) return;

    const accessoryToAdd = {
      title: item.title,
      description: item.description || "",
      price_base: Number(item.price_base ?? item.price ?? 0),
      price_promo: Number(item.price_promo ?? item.price ?? 0),
      price: Number(item.price ?? item.price_promo ?? item.price_base ?? 0),
      type: item.type || "accesorios",
    };

    const updatedPlans = planesFinanciamientoState.map((plan) => {
      if (!plan.isSelected) return plan;

      return recalcularTotalesPlan({
        ...plan,
        accessories: [...(plan.accessories || []), accessoryToAdd],
      });
    });

    setPlanesFinanciamientoState(updatedPlans);

    const updatedSelectedPlan =
      updatedPlans.find((plan) => plan.isSelected === true) || null;

    setPlanSeleccionadoState(updatedSelectedPlan);
  };

  const removeAccessoryFromSelectedPlan = (title) => {
    if (!planSeleccionadoState) return;

    if (esPlanElite(planSeleccionadoState)) {
      Swal.fire({
        icon: "warning",
        title: "Paquete bloqueado",
        text: "El paquete Elite no permite modificaciones.",
      });
      return;
    }

    const updatedPlans = planesFinanciamientoState.map((plan) => {
      if (!plan.isSelected) return plan;

      const nuevosAccesorios = (plan.accessories || []).filter(
        (acc) => normalizar(acc.title) !== normalizar(title),
      );

      return recalcularTotalesPlan({
        ...plan,
        accessories: nuevosAccesorios,
      });
    });

    setPlanesFinanciamientoState(updatedPlans);

    const updatedSelectedPlan =
      updatedPlans.find((plan) => plan.isSelected === true) || null;

    setPlanSeleccionadoState(updatedSelectedPlan);
  };

  const obtenerPrecioVehiculoBase = (data) => {
    const candidatos = [data?.precio_vehiculo];

    for (const valor of candidatos) {
      const numero = Number(
        String(valor ?? "")
          .replace(/,/g, "")
          .replace(/\$/g, ""),
      );
      if (!Number.isNaN(numero) && numero > 0) {
        return numero;
      }
    }

    return 0;
  };

  const guardarEdicionPlan = async () => {
    if (!selectedMailData?.id || !planSeleccionadoState) return;

    setLoading(true);

    try {
      const selectedUpdatedPlan =
        planesFinanciamientoState.find((plan) => plan.isSelected === true) ||
        planSeleccionadoState;

      const precioVehiculo = Math.round(
        obtenerPrecioVehiculoBase(selectedMailData),
      );

      const precioPlan = Math.round(
        Number(selectedUpdatedPlan?.totalPrice || 0),
      );

      const precioTotalFinal = Math.round(precioVehiculo + precioPlan);

      console.log("precioVehiculo detectado:", precioVehiculo);
      console.log("precioPlan detectado:", precioPlan);
      console.log("precioTotalFinal:", precioTotalFinal);

      const payload = {
        access_token: accessToken,
        venta_id: selectedMailData.id,
        planes_financiamiento: planesFinanciamientoState,
        planes_seleccionados: selectedUpdatedPlan?.accessories || [],
        precio_total: precioTotalFinal,
      };

      console.log("Payload actualización planes:", payload);

      const response = await fetch(apiUrlUpdatePlanesSolicitudes, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Plan actualizado",
          text: "Se actualizaron correctamente los accesorios y garantías.",
        });

        setSelectedMailData((prev) =>
          prev
            ? {
                ...prev,
                planes_financiamiento: JSON.stringify(
                  planesFinanciamientoState,
                ),
                planes_seleccionados: JSON.stringify(
                  selectedUpdatedPlan?.accessories || [],
                ),
                precio_total: precioTotalFinal,
              }
            : prev,
        );

        fetchData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "No se pudo actualizar el plan.",
        });
      }
    } catch (error) {
      console.error("Error al guardar el plan:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al guardar los cambios.",
      });
    } finally {
      setLoading(false);
    }
  };

  const actualizarDatoReporte = (campo, valor) => {
    setDatosReporteForm((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };

  const actualizarDatoReporteNumero = (campo, valor) => {
    actualizarDatoReporte(campo, formatearNumeroInput(valor));
  };

  const cancelarEdicionDatosReporte = () => {
    setDatosReporteForm(construirDatosReporteForm(selectedMailData || {}));
    setEditandoDatosReporte(false);
  };

  const guardarDatosReporte = async () => {
    if (!selectedMailData?.id) return;

    const marcaVehiculo = datosReporteForm.marca_vehiculo.trim();
    const modeloVehiculo = datosReporteForm.modelo_vehiculo.trim();
    const anoVehiculo = datosReporteForm.ano_vehiculo.toString().trim();
    const versionVehiculo = datosReporteForm.version_vehiculo.trim();

    const precioVehiculo = Math.round(
      numeroFormulario(datosReporteForm.precio_vehiculo),
    );
    const mesesFinanciamiento = Math.round(
      numeroFormulario(datosReporteForm.meses_financiamiento),
    );
    const enganche = Math.round(numeroFormulario(datosReporteForm.enganche));
    const mensualidad = Math.round(
      numeroFormulario(datosReporteForm.mensualidad_estimacion),
    );
    const mensualidadPayload =
      limpiarNumeroFormulario(datosReporteForm.mensualidad_estimacion) === ""
        ? null
        : mensualidad;

    if (!marcaVehiculo || !modeloVehiculo || !anoVehiculo || !versionVehiculo) {
      Swal.fire({
        icon: "warning",
        title: "Datos incompletos",
        text: "Marca, modelo, año y versión son obligatorios.",
      });
      return;
    }

    if (precioVehiculo <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Precio inválido",
        text: "Ingresa un precio de vehículo válido.",
      });
      return;
    }

    if (!plazoFinanciamientoOptions.includes(mesesFinanciamiento)) {
      Swal.fire({
        icon: "warning",
        title: "Plazo inválido",
        text: "Selecciona un plazo válido: 12, 24, 36, 48, 60 o 72 meses.",
      });
      return;
    }

    const selectedUpdatedPlan =
      planesFinanciamientoState.find((plan) => plan.isSelected === true) ||
      planSeleccionadoState;

    const precioPlan = Math.round(Number(selectedUpdatedPlan?.totalPrice || 0));
    const precioTotalFinal = Math.round(precioVehiculo + precioPlan);

    const payload = {
      access_token: accessToken,
      venta_id: selectedMailData.id,
      marca_vehiculo: marcaVehiculo,
      modelo_vehiculo: modeloVehiculo,
      ano_vehiculo: anoVehiculo,
      version_vehiculo: versionVehiculo,
      precio_vehiculo: precioVehiculo,
      precio_total: precioTotalFinal,
      meses_financiamiento: mesesFinanciamiento,
      enganche,
      mensualidad_estimacion: mensualidadPayload,
    };

    setLoading(true);

    try {
      const response = await fetch(apiUpdateEstadoUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.statusCode === 200 || data.status === "success") {
        const datosActualizados = {
          ...selectedMailData,
          marca_vehiculo: marcaVehiculo,
          modelo_vehiculo: modeloVehiculo,
          ano_vehiculo: anoVehiculo,
          version_vehiculo: versionVehiculo,
          precio_vehiculo: precioVehiculo,
          precio_total: precioTotalFinal,
          meses_financiamiento: mesesFinanciamiento,
          enganche,
          mensualidad_estimacion: mensualidadPayload,
        };

        setSelectedMailData(datosActualizados);
        setMailData((prev) =>
          prev.map((registro) =>
            Number(registro.id) === Number(selectedMailData.id)
              ? datosActualizados
              : registro,
          ),
        );
        setDatosReporteForm(construirDatosReporteForm(datosActualizados));
        setEditandoDatosReporte(false);

        setLoading(false);

        await Swal.fire({
          icon: "success",
          title: "Datos actualizados",
          text: "Se actualizaron correctamente los datos del auto y las condiciones.",
        });

        await fetchData();
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            data.message ||
            "No se pudieron actualizar los datos del auto y condiciones.",
        });
      }
    } catch (error) {
      console.error("Error al actualizar datos de reporte:", error);
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al guardar los cambios.",
      });
    } finally {
      setLoading(false);
    }
  };

  const tipoPagoRaw =
    selectedMailData?.depende_auto ?? selectedMailData?.depente_auto ?? "";

  const tipoPago = String(tipoPagoRaw).trim().toLowerCase();

  const esCredito = tipoPago === "no";
  const esContado = tipoPago === "si" || tipoPago === "sí";

  const statusOptions = esCredito ? statusOptionsCredito : statusOptionsContado;

  const subStatusOptions = esCredito
    ? subStatusOptionsCredito[selectedMailData?.status] || [
        { label: "Sin substatus", value: "Sin substatus" },
      ]
    : [];
  return (
    <div>
      {loading ? (
        <div className="loader-data">
          <Circles height="80" width="80" color="#4fa94d" />
        </div>
      ) : (
        <div>
          <div className="mailbox">
            <div className="mailbox-toolbar">
              {tabs.map((tab) =>
                modules.includes(tab.module) ? (
                  <div className="mailbox-toolbar-item" key={tab.name}>
                    <Link
                      to={tab.to}
                      className={`mailbox-toolbar-link ${
                        location.pathname === tab.to ? "active" : ""
                      }`}
                    >
                      {tab.name}
                    </Link>
                  </div>
                ) : null,
              )}
            </div>
            <div className="d-flex align-items-center mb-3 mt-3">
              <DateRangePicker
                startDate={filters.startDate}
                endDate={filters.endDate}
                onApply={handleDateApplyEvent}
              >
                <a
                  href="#/"
                  className="btn btn-secondary btn-sm d-inline-flex align-items-center"
                >
                  <span>
                    {filters.startDate && filters.endDate
                      ? `${filters.startDate} - ${filters.endDate}`
                      : "Selecciona un rango"}
                  </span>
                  <i className="fa fa-chevron-down ms-2 fs-8px"></i>
                </a>
              </DateRangePicker>
            </div>

            <div className="row">
              <div className="col-6 col-md-2 mb-3">
                <Select
                  options={[
                    { label: "Seleccionar cliente", value: "" },
                    ...filterOptions.nombre.map((nombre) => ({
                      label: nombre,
                      value: nombre,
                    })),
                  ]}
                  value={
                    filters.nombre || filters.apellido_paterno
                      ? {
                          label: [filters.nombre, filters.apellido_paterno]
                            .filter(Boolean)
                            .join(" "),
                          value: [filters.nombre, filters.apellido_paterno]
                            .filter(Boolean)
                            .join(" "),
                        }
                      : { label: "Seleccionar cliente", value: "" }
                  }
                  onChange={(selectedOption) => {
                    const nombreSeparado = separarNombreCompleto(
                      selectedOption?.value || "",
                    );

                    setFilters({
                      ...filters,
                      nombre: nombreSeparado.nombre,
                      apellido_paterno: nombreSeparado.apellido_paterno,
                    });
                  }}
                  styles={customStyles}
                  placeholder="Seleccionar cliente"
                />
              </div>

              <div className="col-6 col-md-2 mb-3">
                <Select
                  options={[
                    { label: "Seleccionar asesor", value: "" },
                    ...filterOptions.asesor.map((asesor) => ({
                      label: asesor,
                      value: asesor,
                    })),
                  ]}
                  value={
                    filters.asesor
                      ? { label: filters.asesor, value: filters.asesor }
                      : { label: "Seleccionar asesor", value: "" }
                  }
                  onChange={(selectedOption) =>
                    setFilters({
                      ...filters,
                      asesor: selectedOption?.value || "",
                    })
                  }
                  styles={customStyles}
                  placeholder="Seleccionar asesor"
                />
              </div>

              <div className="col-6 col-md-2 mb-3">
                <Select
                  options={[
                    { label: "Seleccionar financiera", value: "" }, //del desplegable
                    ...filterOptions.financiera.map((financiera) => ({
                      label: financiera,
                      value: financiera,
                    })),
                  ]}
                  value={
                    filters.financiera
                      ? { label: filters.financiera, value: filters.financiera } //titulo
                      : { label: "Seleccionar financiera", value: "" }
                  }
                  onChange={(selectedOption) =>
                    setFilters({
                      ...filters,
                      financiera: selectedOption?.value || "",
                    })
                  }
                  styles={customStyles}
                  placeholder="Seleccionar financiera"
                />
              </div>

              <div className="col-6 col-md-2 mb-3">
                <Select
                  options={[
                    { label: "Seleccionar status", value: "" }, //desplegable
                    ...filterOptions.status.map((motivo) => ({
                      label: motivo,
                      value: motivo,
                    })),
                  ]}
                  value={
                    filters.status
                      ? {
                          label: filters.status,
                          value: filters.status,
                        }
                      : { label: "Seleccionar status", value: "" } //titulo
                  }
                  onChange={(selectedOption) =>
                    setFilters({
                      ...filters,
                      status: selectedOption?.value || "",
                    })
                  }
                  styles={customStyles}
                  placeholder="Seleccionar status"
                />
              </div>

              <div className="col-6 col-md-2 mb-3">
                <Select
                  options={[
                    { label: "Seleccionar agencia", value: "" },
                    ...filterOptions.agencia.map((nombre) => ({
                      label: nombre,
                      value: nombre,
                    })),
                  ]}
                  value={
                    filters.agencia
                      ? { label: filters.agencia, value: filters.agencia }
                      : { label: "Seleccionar agencia", value: "" }
                  }
                  onChange={(selectedOption) =>
                    setFilters({
                      ...filters,
                      agencia: selectedOption?.value || "",
                    })
                  }
                  styles={customStyles}
                  placeholder="Seleccionar agencia"
                />
              </div>

              {/*<div className="col-6 col-md-2 mb-3">
                <Select
                  options={[
                    { label: "Seleccionar condición", value: "" },
                    ...filterOptions.condicion.map((condicion) => ({
                      label: condicion,
                      value: condicion,
                    })),
                  ]}
                  value={
                    filters.condicion
                      ? { label: filters.condicion, value: filters.condicion }
                      : { label: "Seleccionar condición", value: "" }
                  }
                  onChange={(selectedOption) =>
                    setFilters({
                      ...filters,
                      condicion: selectedOption?.value || "",
                    })
                  }
                  styles={customStyles}
                  placeholder="Seleccionar condición"
                />
              </div>*/}
            </div>

            <div className="mailbox-body" style={{ display: "block" }}>
              <div className="row">
                <div className="col-4">
                  <div
                    className="mailbox-sidebar"
                    style={{ height: "800px", maxWidth: "100%" }}
                  >
                    <PerfectScrollbar className="h-100">
                      <div className="mailbox-list">
                        <div
                          className="p-2 border-bottom bg-white"
                          style={{ position: "sticky", top: 0, zIndex: 3 }}
                        >
                          <label className="form-label mb-1 black-text fw-semibold">
                            Buscar por folio
                          </label>

                          <div style={{ position: "relative" }}>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={folioVentaSearch}
                              onChange={(e) =>
                                setFolioVentaSearch(e.target.value)
                              }
                              placeholder="Ej. FOLIO-001"
                              style={{
                                marginLeft: 0,
                                paddingRight: folioVentaSearch
                                  ? "34px"
                                  : undefined,
                              }}
                            />

                            {folioVentaSearch ? (
                              <button
                                type="button"
                                onClick={() => setFolioVentaSearch("")}
                                aria-label="Limpiar búsqueda"
                                title="Limpiar"
                                style={{
                                  position: "absolute",
                                  top: "50%",
                                  right: "8px",
                                  transform: "translateY(-50%)",
                                  border: 0,
                                  background: "transparent",
                                  color: "#6c757d",
                                  fontSize: "16px",
                                  lineHeight: 1,
                                  padding: 0,
                                  cursor: "pointer",
                                }}
                              >
                                ×
                              </button>
                            ) : null}
                          </div>

                          <div className="small black-text mt-2">
                            Mostrando {mailDataFiltradaPorFolio.length} de{" "}
                            {mailData.length}
                          </div>
                        </div>

                        {mailDataFiltradaPorFolio &&
                        mailDataFiltradaPorFolio.length > 0 ? (
                          mailDataFiltradaPorFolio.map((registro, index) => {
                            const isVentaSeleccionada =
                              String(selectedMailData?.id || "") ===
                              String(registro?.id || "");

                            return (
                              <div
                                key={registro.id || index}
                                className={`mailbox-list-item ${
                                  isVentaSeleccionada ? "active" : ""
                                }`}
                                onClick={() => setSelectedMailData(registro)}
                                style={{
                                  cursor: "pointer",
                                  position: "relative",
                                  borderLeft: isVentaSeleccionada
                                    ? "5px solid #0d6efd"
                                    : "5px solid transparent",
                                  background: isVentaSeleccionada
                                    ? "rgba(13, 110, 253, 0.10)"
                                    : undefined,
                                  boxShadow: isVentaSeleccionada
                                    ? "inset 0 0 0 1px rgba(13, 110, 253, 0.18)"
                                    : undefined,
                                }}
                              >
                                <div className="mailbox-message">
                                  <div className="mailbox-sender">
                                    <span className="mailbox-sender-name">
                                      {getNombreCompleto(registro) || "Sin nombre"}
                                    </span>
                                    <span className="mailbox-time">
                                      {registro.fecha_creacion}
                                    </span>
                                  </div>

                                  <div className="mailbox-sender">
                                    <span className="mailbox-sender-name">
                                      {registro.marca_vehiculo}{" "}
                                      {registro.modelo_vehiculo} -{" "}
                                      {registro.ano_vehiculo}
                                    </span>
                                    <span
                                      className={`mailbox-time fw-semibold ${
                                        isVentaSeleccionada
                                          ? "text-primary"
                                          : ""
                                      }`}
                                    >
                                      {registro.folio_venta || "Sin folio"}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div
                            className="mailbox-list-item"
                            style={{ minWidth: "360px" }}
                          >
                            {folioVentaSearch
                              ? "No hay registros con ese folio"
                              : "No hay registros"}
                          </div>
                        )}
                      </div>
                    </PerfectScrollbar>
                  </div>
                </div>

                <div className="col-8">
                  <div className="mailbox-content" style={{ height: "800px" }}>
                    <PerfectScrollbar className="h-100">
                      {selectedMailData ? (
                        <div className="mailbox-detail">
                          <div className="alert alert-primary d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                            <div>
                              <strong>Venta seleccionada:</strong>{" "}
                              {selectedMailData.folio_venta || "Sin folio"}
                              {getNombreCompleto(selectedMailData)
                                ? ` - ${getNombreCompleto(selectedMailData)}`
                                : ""}
                            </div>
                            <span className="badge bg-primary">
                              Seleccionada
                            </span>
                          </div>

                          <div className="table-container">
                            <Card>
                              <CardHeader className="with-btn">
                                Solicitudes
                                <CardHeaderBtn />
                              </CardHeader>
                              <CardBody>
                                <CardGroup className="m-n1">
                                  <Card className="m-1">
                                    <CardBody>
                                      <h5 className="card-title">
                                        <i className="fas fa-lg fa-fw me-2 fa-box"></i>
                                        Solicitudes (Grupo 1)
                                      </h5>
                                      <table className="table table-striped mb-0">
                                        <tbody>
                                          <tr>
                                            <td className="black-text">
                                              Estado
                                            </td>
                                            <td className="black-text">
                                              <select
                                                className="form-select"
                                                value={
                                                  selectedMailData.status || ""
                                                }
                                                onChange={(e) =>
                                                  updateDataStatus(
                                                    selectedMailData.id,
                                                    e.target.value,
                                                  )
                                                }
                                              >
                                                <option value="">
                                                  Seleccionar status
                                                </option>
                                                {statusOptions.map((option) => (
                                                  <option
                                                    key={option.value}
                                                    value={option.value}
                                                  >
                                                    {option.label}
                                                  </option>
                                                ))}
                                              </select>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </CardBody>
                                  </Card>

                                  {esCredito && (
                                    <Card className="m-1">
                                      <CardBody>
                                        <h5 className="card-title">
                                          <i className="fas fa-lg fa-fw me-2 fa-tasks"></i>
                                          Solicitudes (Grupo 2)
                                        </h5>

                                        <table className="table table-striped mb-0">
                                          <tbody>
                                            <tr>
                                              <td className="black-text">
                                                Estado del Proceso
                                              </td>
                                              <td>
                                                <select
                                                  className="form-select"
                                                  value={
                                                    selectedMailData.sub_status ||
                                                    ""
                                                  }
                                                  onChange={(e) =>
                                                    updateSubStatus(
                                                      selectedMailData.id,
                                                      e.target.value,
                                                    )
                                                  }
                                                >
                                                  <option value="">
                                                    Seleccionar substatus
                                                  </option>
                                                  {subStatusOptions.map(
                                                    (option) => (
                                                      <option
                                                        key={option.value}
                                                        value={option.value}
                                                      >
                                                        {option.label}
                                                      </option>
                                                    ),
                                                  )}
                                                </select>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </CardBody>
                                    </Card>
                                  )}
                                </CardGroup>

                                <CardGroup className="m-n1">
                                  <Card className="m-1">
                                    <CardBody>
                                      <h5 className="card-title">
                                        <i className="fas fa-lg fa-fw me-2 fa-user"></i>
                                        Cliente
                                      </h5>
                                      <table className="table table-striped mb-0">
                                        <tbody>
                                          <tr>
                                            <td className="black-text">
                                              Nombre
                                            </td>
                                            <td className="black-text">
                                              {getNombreCompleto(
                                                selectedMailData,
                                              ) || "Sin nombre"}{" "}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Teléfono
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.telefono}
                                            </td>
                                          </tr>
                                          {/*<tr>
            <td className="black-text">Código Postal</td>
            <td className="black-text">
              {selectedMailData.codigo_postal}
            </td>
          </tr>*/}
                                          <tr>
                                            <td className="black-text">
                                              Correo
                                            </td>
                                            <td className="black-text">
                                              {
                                                selectedMailData.correo_electronico
                                              }
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Fuente
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.fuente}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Folio
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.folio_venta}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Agencia
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.agencia}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Asesor
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.asesor}
                                            </td>
                                          </tr>
                                          {/*<tr>
            <td className="black-text">Comentario</td>
            <td className="black-text">
              {selectedMailData.comentario}
            </td>
          </tr>
          <tr>
            <td className="black-text">Motivo de Rechazo</td>
            <td className="black-text">
              {selectedMailData.motivo_rechazo}
            </td>
          </tr>*/}
                                          <tr>
                                            <td className="black-text">
                                              Fecha de Registro
                                            </td>
                                            <td className="black-text">
                                              {selectedMailData.fecha_creacion}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Financiera
                                            </td>
                                            <td className="black-text">
                                              {/* Botones de acciones */}
                                              <div className="d-flex flex-wrap align-items-center gap-2">
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-primary"
                                                  onClick={() =>
                                                    fileInputRef.current?.click()
                                                  }
                                                  disabled={loading}
                                                >
                                                  <i className="fas fa-camera me-2" />
                                                  Escanear
                                                </button>

                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-secondary"
                                                  onClick={() =>
                                                    verHistorial(
                                                      selectedMailData.id,
                                                    )
                                                  }
                                                  disabled={loading}
                                                >
                                                  <i className="fas fa-history me-2" />
                                                  Status
                                                </button>

                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-secondary"
                                                  onClick={() =>
                                                    verHistorialFinanciera(
                                                      selectedMailData.id,
                                                    )
                                                  }
                                                  disabled={loading}
                                                >
                                                  <i className="fas fa-history me-2" />
                                                  Financieras
                                                </button>

                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-success"
                                                  onClick={() =>
                                                    abrirModalComentario(
                                                      selectedMailData.id,
                                                    )
                                                  }
                                                  disabled={loading}
                                                >
                                                  <i className="fas fa-comment-medical me-2" />
                                                  Agregar comentario
                                                </button>

                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-dark"
                                                  onClick={() =>
                                                    verComentarios(
                                                      selectedMailData.id,
                                                    )
                                                  }
                                                  disabled={loading}
                                                >
                                                  <i className="fas fa-comments me-2" />
                                                  Ver comentarios
                                                </button>

                                                {isAdmin && (
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() =>
                                                      marcarVentaIncompleta(
                                                        selectedMailData,
                                                      )
                                                    }
                                                    disabled={loading}
                                                  >
                                                    <i className="fas fa-trash-alt me-2" />
                                                    Eliminar
                                                  </button>
                                                )}

                                                <input
                                                  type="file"
                                                  accept="application/pdf,image/*"
                                                  ref={fileInputRef}
                                                  style={{ display: "none" }}
                                                  onChange={handleFileChange}
                                                />
                                              </div>

                                              {/* Select debajo */}
                                              <div className="mt-2">
                                                <select
                                                  className="form-select"
                                                  value={currentFinancieraValue}
                                                  onChange={(e) =>
                                                    updateFinanciera(
                                                      selectedMailData.id,
                                                      e.target.value,
                                                    )
                                                  }
                                                  disabled={loading}
                                                >
                                                  <option value="">
                                                    Selecciona la financiera
                                                  </option>
                                                  {bankOptions.map((b) => (
                                                    <option
                                                      key={b.value}
                                                      value={b.value}
                                                    >
                                                      {b.label}
                                                    </option>
                                                  ))}
                                                </select>
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </CardBody>
                                  </Card>
                                </CardGroup>
                                <CardGroup className="m-n1">
                                  <Card className="m-1">
                                    <CardBody>
                                      <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                                        <h5 className="card-title mb-0">
                                          <i className="fas fa-lg fa-fw me-2 fa-car"></i>
                                          Vehículo
                                        </h5>

                                        {!editandoDatosReporte ? (
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-warning"
                                            onClick={() =>
                                              setEditandoDatosReporte(true)
                                            }
                                            disabled={loading}
                                          >
                                            <i className="fas fa-edit me-2" />
                                            Editar auto / condiciones
                                          </button>
                                        ) : (
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-primary"
                                            onClick={
                                              cancelarEdicionDatosReporte
                                            }
                                            disabled={loading}
                                          >
                                            Cancelar edición
                                          </button>
                                        )}
                                      </div>

                                      {editandoDatosReporte && (
                                        <div className="alert alert-warning py-2 mb-2 black-text">
                                          Puedes ajustar estos datos cuando la
                                          solicitud queda condicionada y se
                                          cambia la unidad. El precio total se
                                          recalcula con el precio del vehículo
                                          más el paquete seleccionado.
                                        </div>
                                      )}

                                      <table className="table table-striped mb-0">
                                        <tbody>
                                          <tr>
                                            <td className="black-text">
                                              Marca
                                            </td>
                                            <td className="black-text">
                                              {editandoDatosReporte ? (
                                                <input
                                                  type="text"
                                                  className="form-control form-control-sm"
                                                  value={
                                                    datosReporteForm.marca_vehiculo
                                                  }
                                                  onChange={(e) =>
                                                    actualizarDatoReporte(
                                                      "marca_vehiculo",
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                              ) : (
                                                selectedMailData.marca_vehiculo
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Modelo
                                            </td>
                                            <td className="black-text">
                                              {editandoDatosReporte ? (
                                                <input
                                                  type="text"
                                                  className="form-control form-control-sm"
                                                  value={
                                                    datosReporteForm.modelo_vehiculo
                                                  }
                                                  onChange={(e) =>
                                                    actualizarDatoReporte(
                                                      "modelo_vehiculo",
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                              ) : (
                                                selectedMailData.modelo_vehiculo
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">Tipo</td>
                                            <td className="black-text">
                                              {mostrarTipoAuto(
                                                selectedMailData?.tipo_auto,
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">Año</td>
                                            <td className="black-text">
                                              {editandoDatosReporte ? (
                                                <input
                                                  type="number"
                                                  className="form-control form-control-sm"
                                                  value={
                                                    datosReporteForm.ano_vehiculo
                                                  }
                                                  onChange={(e) =>
                                                    actualizarDatoReporte(
                                                      "ano_vehiculo",
                                                      e.target.value,
                                                    )
                                                  }
                                                  min="1900"
                                                  max="2100"
                                                />
                                              ) : (
                                                selectedMailData.ano_vehiculo
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Versión
                                            </td>
                                            <td className="black-text">
                                              {editandoDatosReporte ? (
                                                <input
                                                  type="text"
                                                  className="form-control form-control-sm"
                                                  value={
                                                    datosReporteForm.version_vehiculo
                                                  }
                                                  onChange={(e) =>
                                                    actualizarDatoReporte(
                                                      "version_vehiculo",
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                              ) : (
                                                selectedMailData.version_vehiculo
                                              )}
                                            </td>
                                          </tr>
                                          {/*<tr>
                                            <td className="black-text">Condición</td>
                                            <td className="black-text">
                                              {selectedMailData.condicion}
                                            </td>
                                          </tr>*/}
                                          <tr>
                                            <td className="black-text">
                                              Precio Vehículo
                                            </td>
                                            <td className="black-text">
                                              {editandoDatosReporte ? (
                                                <input
                                                  type="text"
                                                  inputMode="decimal"
                                                  className="form-control form-control-sm"
                                                  value={
                                                    datosReporteForm.precio_vehiculo
                                                  }
                                                  onChange={(e) =>
                                                    actualizarDatoReporteNumero(
                                                      "precio_vehiculo",
                                                      e.target.value,
                                                    )
                                                  }
                                                  placeholder="Ej. 600,000"
                                                />
                                              ) : (
                                                formatCurrency(
                                                  selectedMailData.precio_vehiculo,
                                                )
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Precio Total
                                            </td>
                                            <td className="black-text">
                                              {editandoDatosReporte ? (
                                                <div>
                                                  <strong>
                                                    {formatCurrency(
                                                      numeroFormulario(
                                                        datosReporteForm.precio_vehiculo,
                                                      ) +
                                                        Number(
                                                          planSeleccionadoState?.totalPrice ||
                                                            0,
                                                        ),
                                                    )}
                                                  </strong>
                                                  <div className="small text-muted black-text">
                                                    Se calcula automáticamente
                                                    con vehículo + paquete.
                                                  </div>
                                                </div>
                                              ) : (
                                                formatCurrency(
                                                  selectedMailData.precio_total,
                                                )
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Financiamiento Meses
                                            </td>
                                            <td className="black-text">
                                              {editandoDatosReporte ? (
                                                <select
                                                  className="form-select form-select-sm"
                                                  value={
                                                    datosReporteForm.meses_financiamiento
                                                  }
                                                  onChange={(e) =>
                                                    actualizarDatoReporte(
                                                      "meses_financiamiento",
                                                      e.target.value,
                                                    )
                                                  }
                                                >
                                                  <option value="">
                                                    Seleccionar plazo
                                                  </option>
                                                  {plazoFinanciamientoOptions.map(
                                                    (meses) => (
                                                      <option
                                                        key={meses}
                                                        value={String(meses)}
                                                      >
                                                        {meses} meses
                                                      </option>
                                                    ),
                                                  )}
                                                </select>
                                              ) : selectedMailData.meses_financiamiento ? (
                                                `${selectedMailData.meses_financiamiento} meses`
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Enganche
                                            </td>
                                            <td className="black-text">
                                              {editandoDatosReporte ? (
                                                <input
                                                  type="text"
                                                  inputMode="decimal"
                                                  className="form-control form-control-sm"
                                                  value={
                                                    datosReporteForm.enganche
                                                  }
                                                  onChange={(e) =>
                                                    actualizarDatoReporteNumero(
                                                      "enganche",
                                                      e.target.value,
                                                    )
                                                  }
                                                  placeholder="Ej. 60,000"
                                                />
                                              ) : (
                                                formatCurrency(
                                                  selectedMailData.enganche,
                                                )
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td className="black-text">
                                              Mensualidad
                                            </td>
                                            <td className="black-text">
                                              {editandoDatosReporte ? (
                                                <input
                                                  type="text"
                                                  inputMode="decimal"
                                                  className="form-control form-control-sm"
                                                  value={
                                                    datosReporteForm.mensualidad_estimacion
                                                  }
                                                  onChange={(e) =>
                                                    actualizarDatoReporteNumero(
                                                      "mensualidad_estimacion",
                                                      e.target.value,
                                                    )
                                                  }
                                                  placeholder="Ej. 20,000"
                                                />
                                              ) : (
                                                formatCurrency(
                                                  getMensualidadSolicitud(
                                                    selectedMailData,
                                                  ),
                                                )
                                              )}
                                            </td>
                                          </tr>

                                          {editandoDatosReporte && (
                                            <tr>
                                              <td colSpan="2">
                                                <div className="d-flex justify-content-end gap-2">
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm btn-warning"
                                                    onClick={
                                                      cancelarEdicionDatosReporte
                                                    }
                                                    disabled={loading}
                                                  >
                                                    Cancelar
                                                  </button>
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary"
                                                    onClick={
                                                      guardarDatosReporte
                                                    }
                                                    disabled={loading}
                                                  >
                                                    Guardar datos
                                                  </button>
                                                </div>
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </CardBody>
                                  </Card>
                                </CardGroup>
                                {/* ===== Card: Entrevista ===== */}
                                <CardGroup className="m-n1">
                                  <Card className="m-1">
                                    <CardBody>
                                      <h5 className="card-title">
                                        <i className="fas fa-lg fa-fw me-2 fa-clipboard-list"></i>
                                        Entrevista
                                      </h5>

                                      {(() => {
                                        const safeJsonParse = (v) => {
                                          if (!v) return null;
                                          if (typeof v === "object") return v;
                                          try {
                                            return JSON.parse(v);
                                          } catch (e) {
                                            return null;
                                          }
                                        };

                                        const get = (
                                          obj,
                                          path,
                                          fallback = "",
                                        ) => {
                                          if (!obj || !path) return fallback;
                                          return (
                                            path
                                              .split(".")
                                              .reduce((acc, key) => {
                                                if (
                                                  acc &&
                                                  Object.prototype.hasOwnProperty.call(
                                                    acc,
                                                    key,
                                                  )
                                                ) {
                                                  return acc[key];
                                                }
                                                return undefined;
                                              }, obj) ?? fallback
                                          );
                                        };

                                        const money = (v) => {
                                          const n = Number(
                                            String(v ?? "").replace(/,/g, ""),
                                          );
                                          if (!isFinite(n) || n === 0)
                                            return "";
                                          return `$${new Intl.NumberFormat(
                                            "es-MX",
                                            {
                                              style: "decimal",
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            },
                                          ).format(Math.round(n))}`;
                                        };

                                        const pretty = (v) => {
                                          if (v === null || v === undefined)
                                            return "";
                                          if (Array.isArray(v))
                                            return v.filter(Boolean).join(", ");
                                          if (typeof v === "boolean")
                                            return v ? "Sí" : "No";

                                          if (typeof v === "string") {
                                            const s = v.trim();
                                            if (!s) return "";
                                            if (/^(si|sí)$/i.test(s))
                                              return "Sí";
                                            if (/^no$/i.test(s)) return "No";
                                            return s;
                                          }

                                          return String(v);
                                        };

                                        const entrevista = safeJsonParse(
                                          selectedMailData?.entrevista,
                                        );

                                        if (!entrevista) {
                                          return (
                                            <div className="text-muted black-text">
                                              No hay entrevista asociada.
                                            </div>
                                          );
                                        }

                                        const tipoAuto = (
                                          selectedMailData?.tipo_auto ||
                                          entrevista?.tipo_auto ||
                                          ""
                                        )
                                          .toString()
                                          .toLowerCase();

                                        const esSeminuevo =
                                          tipoAuto.includes("seminuevo");
                                        const esNuevo =
                                          tipoAuto.includes("nuevo") &&
                                          !tipoAuto.includes("seminuevo");

                                        const blocks = [
                                          {
                                            type: "section",
                                            title: "Entrevista consultiva",
                                          },
                                          {
                                            label:
                                              "¿La compra de su nuevo vehículo sería contado o crédito?",
                                            path: "pago_contado",
                                            format: (v) =>
                                              pretty(v) === "Sí"
                                                ? "Contado"
                                                : pretty(v) === "No"
                                                  ? "Crédito"
                                                  : pretty(v),
                                          },
                                          {
                                            label:
                                              "¿Acepta el seguro de auto dentro del proceso de cotización?",
                                            path: "acepta_seguro_auto",
                                            format: pretty,
                                          },

                                          // CONTADO
                                          {
                                            label:
                                              "¿Tiene definido el presupuesto que desea invertir?",
                                            path: "presupuesto_definido",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                              "Sí",
                                          },
                                          {
                                            label:
                                              "¿Está interesado en conocer opciones de protección o valor agregado para su vehículo?",
                                            path: "interes_proteccion",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                              "Sí",
                                          },

                                          // CRÉDITO
                                          {
                                            label:
                                              "¿Cuenta con historial de crédito?",
                                            path: "historial_credito",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                              "No",
                                          },
                                          {
                                            label:
                                              "¿Cuánto de inversión inicial contempla?",
                                            custom: (obj) =>
                                              obj?.engancheEditable ||
                                              obj?.enganche ||
                                              obj?.inversion_inicial,
                                            format: (v) =>
                                              money(v) || pretty(v),
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                              "No",
                                          },
                                          {
                                            label:
                                              "¿Qué mensualidad está buscando?",
                                            path: "mensualidad_buscada",
                                            format: (v) =>
                                              money(v) || pretty(v),
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                              "No",
                                          },
                                          {
                                            label: "¿Comprueba ingresos?",
                                            path: "comprueba_ingresos",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                              "No",
                                          },

                                          // CRÉDITO - SI COMPRUEBA
                                          {
                                            label:
                                              "¿Su actividad es asalariado o independiente?",
                                            path: "tipo_actividad",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "Sí",
                                          },
                                          {
                                            label: "Actividad de la empresa",
                                            path: "actividad_empresa",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "Sí",
                                          },
                                          {
                                            label:
                                              "Fecha de Ingreso o Inicio de actividades",
                                            path: "fecha_inicio_actividades",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "Sí",
                                          },
                                          {
                                            label: "Nombre empresa o negocio",
                                            path: "nombre_empresa_negocio",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "Sí",
                                          },
                                          {
                                            label:
                                              "¿Cuál es su ingreso mensual?",
                                            path: "ingreso_mensual",
                                            format: (v) =>
                                              money(v) || pretty(v),
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "Sí",
                                          },

                                          // CRÉDITO - NO COMPRUEBA
                                          {
                                            label: "¿Cuál es su actividad?",
                                            path: "actividad_no_comprobable",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "No",
                                          },
                                          {
                                            label:
                                              "Fecha de Inicio de actividades",
                                            path: "fecha_inicio_actividades_no_comprobable",
                                            format: pretty,
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "No",
                                          },
                                          {
                                            label:
                                              "¿Cuál es su ingreso mensual no comprobable?",
                                            path: "ingreso_mensual_no_comprobable",
                                            format: (v) =>
                                              money(v) || pretty(v),
                                            showIf: (obj) =>
                                              pretty(obj?.pago_contado) ===
                                                "No" &&
                                              pretty(
                                                obj?.comprueba_ingresos,
                                              ) === "No",
                                          },

                                          {
                                            type: "separator",
                                            title:
                                              "Identificación de necesidades de garantías",
                                          },
                                          {
                                            label:
                                              "¿Cómo son generalmente las calles por las que suele manejar?",
                                            path: "condiciones_calle_extra",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Ha extraviado alguna vez una llave de su auto o le preocupa el costo de una reposición?",
                                            path: "interes_llaves",
                                            format: pretty,
                                            showIf: () => esNuevo,
                                          },
                                          {
                                            label:
                                              "¿Ha tenido que dejar su auto en el taller por unos días tras un siniestro o reparación?",
                                            path: "ha_dejado_taller",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "Al adquirir un auto seminuevo, ¿le interesaría tener la tranquilidad de una garantía similar a la de un auto nuevo?",
                                            path: "garantia_seminuevo",
                                            format: pretty,
                                            showIf: () => esSeminuevo,
                                          },
                                          {
                                            label:
                                              "Para mayor privacidad y discreción al conducir, ¿le interesaría que su vehículo incluya polarizado que limite la visibilidad hacia el interior?",
                                            path: "desea_polarizado",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "Para mayor tranquilidad ante cualquier eventualidad, ¿le interesaría que su vehículo incluya un Kit de Emergencia completo desde la entrega?",
                                            path: "desea_kit_emergencia",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Le gustaría saber en tiempo real dónde se encuentra su auto todo el tiempo?",
                                            path: "tiempo_real",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Es importante para usted un respaldo que ayude a recuperar el auto en caso de robo?",
                                            path: "respaldo_auto",
                                            format: pretty,
                                          },

                                          {
                                            type: "separator",
                                            title: "Sabone",
                                          },
                                          {
                                            label:
                                              "¿Tiene vehículo actualmente?",
                                            path: "entrevista_nissan.tiene_vehiculo_actual",
                                            format: pretty,
                                          },
                                          {
                                            label: "¿Qué busca de su vehículo?",
                                            path: "entrevista_nissan.busca_en_vehiculo",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Quién manejaría el vehículo?",
                                            path: "entrevista_nissan.quien_manejara",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Qué uso le dará a su vehículo?",
                                            path: "entrevista_nissan.uso_vehiculo",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Qué factor considera importante para la compra de su vehículo?",
                                            path: "entrevista_nissan.factor_importante_compra",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Viaja en carretera regularmente?",
                                            path: "entrevista_nissan.viaja_carretera",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Para cuándo quiere realizar la compra del vehículo?",
                                            path: "entrevista_nissan.cuando_compra",
                                            format: pretty,
                                          },
                                          {
                                            label:
                                              "¿Usted tomaría la decisión de compra?",
                                            path: "entrevista_nissan.toma_decision_compra",
                                            format: pretty,
                                          },
                                          {
                                            label: "Motivantes de compra",
                                            path: "entrevista_nissan.motivantes_compra",
                                            format: pretty,
                                          },
                                        ];

                                        const obtenerValorBloque = (b) => {
                                          if (
                                            typeof b.showIf === "function" &&
                                            !b.showIf(entrevista)
                                          ) {
                                            return "";
                                          }

                                          const rawValue =
                                            typeof b.custom === "function"
                                              ? b.custom(entrevista)
                                              : get(entrevista, b.path, "");

                                          return (
                                            (b.format
                                              ? b.format(rawValue)
                                              : pretty(rawValue)) || ""
                                          );
                                        };

                                        const rows = [];
                                        let seccionPendiente = null;
                                        let seccionTieneRespuestas = false;

                                        const agregarSeccionPendiente = () => {
                                          if (
                                            !seccionPendiente ||
                                            !seccionTieneRespuestas
                                          ) {
                                            seccionPendiente = null;
                                            seccionTieneRespuestas = false;
                                            return;
                                          }

                                          rows.push(
                                            <tr
                                              key={`sep-${seccionPendiente.idx}`}
                                            >
                                              <td
                                                colSpan={2}
                                                className="fw-bold table-active"
                                              >
                                                {seccionPendiente.title}
                                              </td>
                                            </tr>,
                                          );

                                          rows.push(...seccionPendiente.rows);

                                          seccionPendiente = null;
                                          seccionTieneRespuestas = false;
                                        };

                                        blocks.forEach((b, idx) => {
                                          if (
                                            b.type === "section" ||
                                            b.type === "separator"
                                          ) {
                                            agregarSeccionPendiente();

                                            seccionPendiente = {
                                              idx,
                                              title: b.title,
                                              rows: [],
                                            };
                                            seccionTieneRespuestas = false;
                                            return;
                                          }

                                          const value = obtenerValorBloque(b);

                                          if (!value) return;

                                          const row = (
                                            <tr key={`q-${idx}`}>
                                              <td className="black-text">
                                                {b.label}
                                              </td>
                                              <td className="black-text">
                                                {value}
                                              </td>
                                            </tr>
                                          );

                                          if (seccionPendiente) {
                                            seccionPendiente.rows.push(row);
                                            seccionTieneRespuestas = true;
                                          } else {
                                            rows.push(row);
                                          }
                                        });

                                        agregarSeccionPendiente();

                                        return (
                                          <table className="table table-striped mb-0">
                                            <tbody>
                                              {rows.length ? (
                                                rows
                                              ) : (
                                                <tr>
                                                  <td colSpan="2">
                                                    No hay respuestas para
                                                    mostrar
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        );
                                      })()}
                                    </CardBody>
                                  </Card>
                                </CardGroup>

                                <CardGroup className="m-n1">
                                  <Card className="m-1">
                                    <CardBody>
                                      <h5 className="card-title">
                                        <i className="fas fa-lg fa-fw me-2 fa-box"></i>
                                        Paquete seleccionado
                                      </h5>

                                      <p className="black-text mb-3">
                                        <strong>
                                          {planSeleccionadoState?.title ||
                                            "Sin paquete seleccionado"}
                                        </strong>
                                      </p>

                                      <p className="black-text mb-3">
                                        <strong>Total del paquete:</strong>{" "}
                                        {`$${new Intl.NumberFormat("es-MX", {
                                          style: "decimal",
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 0,
                                        }).format(
                                          Number(
                                            planSeleccionadoState?.totalPrice ||
                                              0,
                                          ),
                                        )}`}
                                      </p>
                                      {aplicaDescuentoPaquete ? (
                                        <p className="text-success mb-3">
                                          Se aplicó 10% de descuento al paquete
                                          por exceder $
                                          {new Intl.NumberFormat("es-MX", {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0,
                                          }).format(LIMITE_DESCUENTO)}
                                          .
                                        </p>
                                      ) : (
                                        <p className="text-warning mb-3">
                                          Le faltan{" "}
                                          <strong>
                                            $
                                            {new Intl.NumberFormat("es-MX", {
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 0,
                                            }).format(faltaParaDescuento)}
                                          </strong>{" "}
                                          para obtener el 10% de descuento.
                                        </p>
                                      )}

                                      <table className="table table-striped mb-0">
                                        <thead>
                                          <tr>
                                            <th className="black-text">
                                              Producto
                                            </th>
                                            <th className="black-text">
                                              Precio
                                            </th>
                                            <th className="black-text">Tipo</th>
                                            <th className="black-text">
                                              Acción
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {(
                                            planSeleccionadoState?.accessories ||
                                            []
                                          ).length > 0 ? (
                                            (
                                              planSeleccionadoState?.accessories ||
                                              []
                                            ).map((producto, index) => (
                                              <tr key={index}>
                                                <td className="black-text">
                                                  {
                                                    (
                                                      producto.title ||
                                                      "Sin título"
                                                    ).split(" - ")[0]
                                                  }
                                                </td>
                                                <td className="black-text">
                                                  {producto.price !== undefined
                                                    ? `$${new Intl.NumberFormat(
                                                        "es-MX",
                                                        {
                                                          style: "decimal",
                                                          minimumFractionDigits: 0,
                                                          maximumFractionDigits: 0,
                                                        },
                                                      ).format(
                                                        Number(
                                                          producto.price || 0,
                                                        ),
                                                      )}`
                                                    : "Sin precio"}
                                                </td>
                                                <td className="black-text">
                                                  {producto.type ||
                                                    "accesorios"}
                                                </td>
                                                <td className="black-text">
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm btn-danger"
                                                    disabled={esPlanElite(
                                                      planSeleccionadoState,
                                                    )}
                                                    onClick={() =>
                                                      removeAccessoryFromSelectedPlan(
                                                        producto.title,
                                                      )
                                                    }
                                                  >
                                                    Quitar
                                                  </button>
                                                </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan="4"
                                                className="black-text"
                                              >
                                                No hay productos asociados
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </CardBody>
                                  </Card>
                                </CardGroup>

                                <Card className="mt-3">
                                  <CardBody>
                                    <h5 className="card-title">
                                      <i className="fas fa-lg fa-fw me-2 fa-plus-circle"></i>
                                      Accesorios / garantías disponibles
                                    </h5>

                                    <table className="table table-striped mb-0">
                                      <thead>
                                        <tr>
                                          <th className="black-text">
                                            Producto
                                          </th>
                                          <th className="black-text">Precio</th>
                                          <th className="black-text">Tipo</th>
                                          <th className="black-text">Acción</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {filteredAccessoriesAndWarranties.length >
                                        0 ? (
                                          filteredAccessoriesAndWarranties.map(
                                            (item, index) => (
                                              <tr key={index}>
                                                <td className="black-text">
                                                  {
                                                    (
                                                      item.title || "Sin título"
                                                    ).split(" - ")[0]
                                                  }
                                                </td>
                                                <td className="black-text">
                                                  $
                                                  {new Intl.NumberFormat(
                                                    "es-MX",
                                                    {
                                                      minimumFractionDigits: 0,
                                                      maximumFractionDigits: 0,
                                                    },
                                                  ).format(
                                                    Number(item.price || 0),
                                                  )}
                                                </td>
                                                <td className="black-text">
                                                  {item.type || "accesorios"}
                                                </td>
                                                <td className="black-text">
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm btn-success"
                                                    disabled={esPlanElite(
                                                      planSeleccionadoState,
                                                    )}
                                                    onClick={() =>
                                                      addAccessoryToSelectedPlan(
                                                        item,
                                                      )
                                                    }
                                                  >
                                                    Agregar
                                                  </button>
                                                </td>
                                              </tr>
                                            ),
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan="4"
                                              className="black-text"
                                            >
                                              No hay accesorios ni garantías
                                              disponibles para esta marca.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>

                                    <div className="mt-3 text-end">
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={guardarEdicionPlan}
                                        disabled={
                                          loading ||
                                          !selectedMailData ||
                                          !planSeleccionadoState
                                        }
                                      >
                                        Guardar cambios del paquete
                                      </button>
                                    </div>
                                  </CardBody>
                                </Card>
                              </CardBody>
                            </Card>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="mailbox-detail-placeholder"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            textAlign: "center",
                          }}
                        >
                          Seleccione un cliente para ver los detalles
                        </div>
                      )}
                    </PerfectScrollbar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UpdateDetail;
